/*:: type BusinessInitObject = {
  id?: string,
  slug: string,
  name: string,
  shortName: string,
  slogan?: string,
  description?: string,
  url?: string,
  phone?: string,
  categories?: Array<Object>,
  profileImage?: ?string,
  logoImage?: ?string,
  heroImage?: ?string,
  isEnabled?: ?boolean,
  locations?: Array<Object>,
  policies?: Array<Object>,
  socialProfiles?: JSON,
  meta?: JSON,
  generatedContextStatus?: string
};*/

class Business {
  constructor({
    /*: BusinessInitObject*/

    id,
    slug,
    name,
    shortName,
    slogan,
    description,
    url,
    phone,
    categories = [],
    tags = [],
    profileImage,
    logoImage,
    heroImage,
    isEnabled,
    localizations,
    locations,
    plan,
    socialProfiles,
    meta,
    generatedContextStatus,
    profileImages
  }) {
    this.id = id;
    this.slug = slug;
    this.name = name;
    this.shortName = shortName;
    this.slogan = slogan;
    this.description = description;
    this.url = url;
    this.phone = phone;
    this.categories = categories;
    this.tags = tags;
    this.profileImage = profileImage;
    this.logoImage = logoImage;
    this.heroImage = heroImage;
    this.isEnabled = isEnabled;
    this.localizations = localizations;
    this.locations = locations;
    this.plan = plan;
    this.socialProfiles = socialProfiles;
    this.meta = meta;
    this.generatedContextStatus = generatedContextStatus;
    this.profileImages = profileImages;
  }

}

module.exports = Business;